import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { t } from 'utils/routeTitle';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/sites/$siteId')({
  staticData: { routeTitle: t('common.manage_site') },
  beforeLoad: ctx => {
    if (!/^\d+$/.test(ctx.params.siteId)) {
      throw redirect({ to: '/n/not-found', replace: true });
    }
    return requireActivePlan(ctx);
  },
  component: SiteIdLayout,
});

function SiteIdLayout() {
  return <Outlet />;
}
